import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function IntroModal({ on_dismiss }) {
	return (
		<Modal show dialogClassName="intro-modal-dialog" centered>
			<Modal.Header>
				<Modal.Title>Welcome to AI Call Trainer</Modal.Title>
			</Modal.Header>
			<Modal.Body className="intro-modal-body">
				<p>Here's how to get started:</p>
				<ol>
					<li>
						<strong>Go to Calls</strong> - Click <em>Calls</em> in the menu and choose a persona to practice with.
					</li>
					<li>
						<strong>Create a Sales Profile</strong> - When prompted, use the <em>Select a Sales Profile</em> modal to create a profile describing your product or service. This gives the AI prospect context about what you're selling.
					</li>
					<li>
						<strong>Start the Call</strong> - Once your sales profile is set, start the call. The AI will play the role of a prospect.
					</li>
					<li>
						<strong>Practice</strong> - Respond naturally. Use voice mode for a realistic experience, or type your replies. The prospect will push back, ask questions, and react to your approach. Use the 3A method to handle objections.
					</li>
					<li>
						<strong>Get Reviewed</strong> - When the call ends, request a coach review to get a grade (A-F) and detailed feedback on your performance.
					</li>
					<li>
						<strong>Track Progress</strong> - Visit the <em>Dashboard</em> to see your call history, scores, and improvement over time.
					</li>
				</ol>
				<p>Good luck, and remember: the more you practice, the better you get.</p>
				<p>You can revisit these instructions any time from the <strong>Help</strong> section in the side menu.</p>
			</Modal.Body>
			<Modal.Footer className="intro-modal-footer">
				<Button className="intro-modal-btn" onClick={on_dismiss}>Get Started</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default IntroModal;
